import { useState } from "react";
import { Plus } from "lucide-react";
import { Chapter, Reveal } from "./Shared";

const FAQS = [
  {
    q: "Will you sell my design to another Etsy seller?",
    a: "Never. Every design is created exclusively for your account and is never shown, shared, or resold to anyone else.",
  },
  {
    q: "Can I use designs on Printify and Printful?",
    a: "Yes — your 300 DPI transparent PNGs are production-ready for Printify, Printful, and every major print-on-demand platform.",
  },
  {
    q: "Do I own the designs after delivery?",
    a: "Yes. Full commercial rights transfer to you on delivery — use them on any product, in any store, forever.",
  },
  {
    q: "Can I sell them as digital downloads?",
    a: "Yes. Your commercial license covers digital downloads alongside physical products.",
  },
  {
    q: "Can I modify the designs?",
    a: "Yes. The files are yours to adapt, recolor, and resize for your listings.",
  },
  {
    q: "What happens if I don't like the result?",
    a: "Tell us — we revise the design until it matches your brief and is production-ready.",
  },
  {
    q: "Do you use AI to create designs?",
    a: "No. Every file is crafted by human vector artists and typographers — zero AI generation.",
  },
  {
    q: "What happens if you miss the delivery deadline?",
    a: "Deliveries land before 8 AM EST — if a file ever misses the window, it becomes our first job the next morning.",
  },
  {
    q: "Can I cancel my subscription?",
    a: "Yes, one click from your dashboard — your plan stays active until the end of the current billing period.",
  },
  {
    q: "Do unused design credits expire?",
    a: "Credits reset at the start of each billing cycle and don't roll over — use them any time during the month, with no daily caps.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="relative">
      <div className="mx-auto max-w-3xl px-6 py-16 sm:py-20">
        <Reveal className="text-center">
          <Chapter num="10" label="Straight Answers" className="justify-center" />
          <h2 className="mt-6 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Questions, answered before you ask
          </h2>
        </Reveal>

        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={Math.min(i * 0.04, 0.3)}>
                <div
                  data-testid={`faq-item-${i}`}
                  className={`rounded-2xl border transition-colors duration-300 ${
                    isOpen
                      ? "border-amber-400/40 bg-[#0C1222]/90"
                      : "border-white/10 bg-[#0C1222]/60 hover:border-white/20"
                  }`}
                >
                  <button
                    data-testid={`faq-question-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  >
                    <span className="text-sm font-bold text-white sm:text-base">{f.q}</span>
                    <Plus
                      className={`h-4 w-4 shrink-0 text-amber-300 transition-transform duration-300 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    />
                  </button>
                  {isOpen && (
                    <p
                      data-testid={`faq-answer-${i}`}
                      className="px-6 pb-5 text-sm leading-relaxed text-slate-300"
                    >
                      {f.a}
                    </p>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}